<template>
  <MenusContainer
    :menus="permissionMenus"
    :show-menu="!isFromWorkbench"
    :app="true"
  />
</template>

<script>
import MenusContainer from "@/components/MenusContainer";
import { ROLE_TYPE } from "@/types/role.type";
export default {
  components: {
    MenusContainer,
  },
  data() {
    return {
      menus: [
        {
          title: "职工休假",
          active: true,
          children: [
            {
              title: "申请休假",
              path: "/personnel/leave-apply",
            },
            {
              title: "我的申请",
              path: "/personnel/leave-list",
            },
            {
              title: "单位休假",
              path: "/personnel/leave-org-list",
              permission: ROLE_TYPE.HR_ADMIN,
            },
            {
              title: "部门休假",
              path: "/personnel/leave-dep-list",
              permission: ROLE_TYPE.HR_ADMIN,
            },
            {
              title: "我的销假",
              path: "/personnel/cancel-leave-list",
              hide: true,
            },
          ],
        },
        {
          title: "职工考勤",
          active: true,
          hide: true,
          children: [
            {
              title: "考勤打卡",
              path: "/personnel/punch-card",
              hide: !this.$vuetify.breakpoint.mobile,
            },
            {
              title: "考勤日历",
              path: "/personnel/attendance-calendar",
              hide: true,
            },
            {
              title: "我的考勤",
              path: "/personnel/attendance-list",
              hide: true,
            },
            {
              title: "部门考勤",
              path: "/personnel/attendance-org-list",
              permission: ROLE_TYPE.HR_ADMIN,
              hide: true,
            },
            {
              title: "我的申诉",
              path: "/personnel/attendance-appeal-list",
              hide: true,
            },
          ],
        },
        {
          title: "外出报备",
          active: true,
          hide: true,
          children: [
            {
              title: "我的报备",
              path: "/personnel/out-report-list",
              hide: true,
            },
            {
              title: "申请外出",
              path: "/personnel/out-report-form",
              hide: true,
            },
            {
              title: "单位报备",
              path: "/personnel/out-report-org-list",
              permission: ROLE_TYPE.HR_ADMIN,
              hide: true,
            },
          ],
        },
        {
          title: "基础设置",
          permission: ROLE_TYPE.HR_ADMIN,
          active: true,
          children: [
            {
              title: "考勤设置",
              path: "/personnel/attendance-config",
              hide: false,
            },
            {
              title: "休假类型设置",
              path: "/personnel/leave-type-list",
            },
            {
              title: "节假日设置",
              path: "/personnel/holiday-config",
              hide: false,
            },
            {
              title: "年休假设置",
              path: "/personnel/annual-leave-org-list",
              hide: false,
            },
          ],
        },
      ],
    };
  },
  computed: {
    isFromWorkbench() {
      return this.$route.query.type;
    },
    permissionMenus() {
      const rolesList = this.$store.getters.rolesList;
      const originList = this.menus
        .filter((i) => !i.hide)
        .reduce((list, current) => {
          const item = { ...current };
          item.children = [...item.children];
          list.push(item);
          return list;
        }, []);

      const result = originList.filter((parent) => {
        parent.children = parent.children.filter(
          (i) =>
            i.permission === undefined ||
            rolesList.some((role) => role.includes(i.permission))
        );

        return (
          parent.permission === undefined ||
          rolesList.some((role) => role.includes(parent.permission))
        );
      });

      return result;
    },
  },
  async created() {
    await this.$store.dispatch("getRoles");
  },
};
</script>

<style></style>
